import Vue from 'vue';
import Vuex from 'vuex';
import shelly from './modules/shelly';
import auth from './modules/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    shelly,
    auth
  }
});
